module.exports = __webpack_public_path__ + "img/DiHS_Dashboard_Icon_buchung 3.b2fa3fd6.svg";